import { PictureDesktopNames, PictureTransformations } from '../picture';

export const GALLERY_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 1440,
    height: 905,
    objectFit: 'fill',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 736,
    height: 440,
    objectFit: 'fill',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 768,
    height: 482,
    objectFit: 'fill',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 320,
    height: 203,
    objectFit: 'fill',
  },
};
